// AUTO-GENERATED — DO NOT EDIT THIS FILE DIRECTLY.
//
// Synced from api/client.js
// by scripts/sync_wallet_app.sh on 2026-07-17T08:09:17Z.
//
// To make changes:
//   1. Edit react/_shared/wallet-app/api/client.js
//   2. Run ./scripts/sync_wallet_app.sh
//
// Editing this copy in place will be overwritten on next sync.
//
// ---------------------------------------------------------------

// api/client.js
//
// Single API-call envelope for the Bankcoin customer apps. Mirrors
// react/bankcoin-web/src/api/client.js + react/depositor-web-v2/src/api/
// stablecoinApi.js: a uniform `{ ok, data?, unavailable?, error?, status? }`
// shape with `unavailable: true` for 404/501 (route not yet deployed) so the
// UI can render "coming soon" gates rather than scary error screens.
//
// Base URL is api.bankcoin.capital in production, configurable via env:
//   VITE_API_URL          (preferred)
//   VITE_RATE_SERVER_URL  (depositor-web-v2 fallback, supported for parity)
//   ''                    (same-origin, dev nginx proxy)
//
// Every mutation auto-attaches an Idempotency-Key header. The server
// enforces this on every money-affecting POST; doing it client-side here
// removes the chance a money-moving call ever ships without one (the
// CLAUDE.md non-negotiable rule).

const RAW_BASE =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_URL) ||
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_RATE_SERVER_URL) ||
  '';

export const API_BASE = String(RAW_BASE).replace(/\/$/, '');

export const buildUrl = (path) =>
  path.startsWith('http') ? path : `${API_BASE}${path}`;

export function qs(params) {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(params ?? {})) {
    if (v !== undefined && v !== null && v !== '') sp.set(k, String(v));
  }
  const s = sp.toString();
  return s ? `?${s}` : '';
}

export function newIdempotencyKey() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `idem-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

/**
 * The single fetch wrapper. Optionally attaches a Bearer token, always
 * attaches Idempotency-Key on POST/PUT, always resolves to a uniform
 * envelope. Never throws — network errors → `{ ok: false, error }`.
 *
 * @param {string} path     - Relative path like `/bridge/start` or full URL
 * @param {RequestInit} options - Standard fetch options
 * @param {string|null} token   - JWT bearer (optional)
 * @returns {Promise<{ok:boolean, data?:any, unavailable?:boolean, error?:string, status?:number}>}
 */
export async function apiCall(path, options = {}, token = null) {
  const headers = new Headers(options.headers || {});
  if (token) headers.set('Authorization', `Bearer ${token}`);

  if (
    options.body &&
    typeof options.body === 'string' &&
    !headers.has('Content-Type')
  ) {
    headers.set('Content-Type', 'application/json');
  }

  const method = (options.method ?? 'GET').toUpperCase();
  if (
    (method === 'POST' || method === 'PUT' || method === 'PATCH') &&
    !headers.has('Idempotency-Key')
  ) {
    headers.set('Idempotency-Key', newIdempotencyKey());
  }

  let res;
  try {
    res = await fetch(buildUrl(path), { ...options, headers });
  } catch (e) {
    return { ok: false, error: e?.message || 'network error' };
  }

  if (res.status === 404 || res.status === 501) {
    return { ok: false, unavailable: true, status: res.status };
  }

  let body = null;
  try {
    body = await res.json();
  } catch {
    body = null;
  }

  if (!res.ok) {
    return {
      ok: false,
      status: res.status,
      error: body?.error || body?.message || `HTTP ${res.status}`,
      data: body,
    };
  }

  return { ok: true, data: body, status: res.status };
}

export function jsonBody(obj) {
  return { body: JSON.stringify(obj) };
}
